//======> Docementation <======//
registerBlockType('tornado/aboutus-section1', {
    title: __(' عن الشركة الجزء الأول', 'tornado'),
    description: __('عن الشركة الجزء الأول', 'tornado'),
    icon:'feedback',
    category: 'tornado',
    keywords: [ 'tornado', 'section' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
        section_title : {
            type: 'string',
            source: 'html',
            selector: '.title',
            default: 'من نحن',
        },
        section_description : {
            type: 'string',
            source: 'html',
            selector: '.desc1',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        section_description_2 : {
            type: 'string',
            source: 'html',
            selector: '.desc2',
            default: 'إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية، مولد النص العربى مفيد لمصممي المواقع على وجه الخصوص، حيث يحتاج العميل فى كثير من الأحيان أن يطلع على صورة حقيقية لتصميم',
        },
        section_image : {
            type: 'string',
            default: 'http://via.placeholder.com/200x200',
        },
        description_control : {
            type: 'string',
            default : 'enable',
        },
        description_control2 : {
            type: 'string',
            default : 'disable',
        },
        page_control : {
            type: 'string',
            default : '',
        },
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Main ====//
        const set_section_title = section_title => { setAttributes({section_title}) };
        const set_section_description = section_description => { setAttributes({section_description}) };
        const set_section_description_2 = section_description_2 => { setAttributes({section_description_2}) };
        const set_description_control = description_control => { setAttributes({description_control}) };
        const set_description_control2 = description_control2 => { setAttributes({description_control2}) };
        const set_page_control = page_control => { setAttributes({page_control}) };
        //==== Images and icons Uploader ====//
        const section_image = (openEvent) => {
            return(<img src={ attributes.section_image } alt={ attributes.section_title } onClick={ openEvent } />)
        };
        //==== Block Structure ====//
        return (
            <Panel>
                <PanelBody>
                    <InspectorControls key="inspector">
                        <PanelBody title={ __('Block Options', 'tornado') }>
                                <SelectControl key="page-controler" label="اختيار الصفحه" value={ attributes.page_control }
                                    options={[
                                        { label: 'Home', value: '' },
                                        { label: 'About', value: 'inside' },
                                    ]}
                                    onChange={set_page_control}
                                />
                                <SelectControl key="description-control" label="اظهار / اخفاء الوصف" value={ attributes.description_control }
                                    options={[
                                        { label: 'ظهور', value: 'enable' },
                                        { label: 'اخفاء', value: 'disable' },
                                    ]}
                                    onChange={set_description_control}
                                />
                                <SelectControl key="description-control2" label="اظهار / اخفاء الوصف 2" value={ attributes.description_control2 }
                                    options={[
                                        { label: 'ظهور', value: 'enable' },
                                        { label: 'اخفاء', value: 'disable' },
                                    ]}
                                    onChange={set_description_control2}
                                />
                                <MediaUpload render={({open}) => section_image(open)} value={ attributes.section_image }  onSelect={media => { setAttributes({section_image: media.url}); }} type="image" />
                        </PanelBody>
                    </InspectorControls>
                <div className={'about-us v2 inside '+attributes.page_control}>
                    {/*<!-- Grid -->*/}
                    <div className="row no-gutter overflow">
                        {/*<!-- image -->*/}
                        <div className="col-12 col-m-5 wow fadeInRight">
                            <div className="content-box">
                                <img src={attributes.section_image} alt={attributes.section_title} />
                            </div>
                        </div>
                        {/*<!-- Content -->*/}
                        <div className="col-12 col-m-7">
                            <RichText tagName="h3" data-delay=".3s" className="title" onChange={ set_section_title } value={ attributes.section_title } />
                            {attributes.description_control === 'enable' &&<RichText tagName="p"  data-delay=".6s" className="desc1" onChange={ set_section_description } value={ attributes.section_description } />}
                            {attributes.description_control2 === 'enable' &&<RichText tagName="p"  data-delay=".9s" className="desc2" onChange={ set_section_description_2 } value={ attributes.section_description_2 } />}
                        </div>
                        {/*<!-- // Content -->*/}
                    </div>
                    {/*<!-- // Grid -->*/}
                </div>            
                </PanelBody>
            </Panel>
        );
    },
    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes } = props;

        //==== Block Structure ====//
        return (
            <div className={'about-us v2 '+attributes.page_control}>
                {/*<!-- Grid -->*/}
                <div className="row no-gutter overflow">
                    {/*<!-- Image -->*/}
                    <div className="col-12 col-m-5 wow fadeInRight">
                        <div className="content-box">
                            <img src={attributes.section_image} alt={attributes.section_title} />
                        </div>    
                    </div>
                    {/*<!-- Content -->*/}
                    <div className="col-12 col-m-7">
                        <h3 className="title" data-delay=".3s">{attributes.section_title}</h3>
                        {attributes.description_control === 'enable' &&<p className="desc1"  data-delay=".6s">{attributes.section_description}</p>}
                        {attributes.description_control2 === 'enable' &&<p className="desc2"  data-delay=".9s">{attributes.section_description_2}</p>}
                    </div>
                    {/*<!-- Content -->*/}
                </div>
                {/*<!-- // Grid -->*/}
            </div>
        );
    },
});